import React from 'react'

import {
  Group,
  Pagination,
  Select,
  SelectItem,
  Stack,
  Text,
} from '@mantine/core'

import { PaginationBarProps } from './pagination-bar'

const PaginationBar = ({
  active,
  setPage,
  total,
  siblings,
  size = 'md',
  perPage,
  withEdges = true,
  countTextOrientation = 'stack',
  setPerPage,
  perPageSelectInputProps = {
    size: 'xs',
  },
  next: _next,
  previous: _previous,
  first: _first,
  last: _last,
  setTotal: _setTotal,
  isLoading = false,
  isError: _isError,
  ...paginationProps
}: PaginationBarProps): React.ReactElement => {
  const disabled = isLoading || Math.ceil(total / perPage) === 0
  const pagination = (
    <Group
      position="right"
      align="end"
    >
      <Pagination
        disabled={disabled}
        value={active}
        onChange={(x) => {
          setPage(x)
        }}
        total={Math.ceil(total / perPage) > 0 ? Math.ceil(total / perPage) : 1}
        siblings={siblings}
        withEdges={withEdges}
        size={size}
        {...paginationProps}
      />

      <Select
        disabled={disabled}
        data={['10', '25', '50', '75', '100', '200', '500', '1000', '2500'].map(
          (perPage): SelectItem => ({
            value: perPage,
            label: i18n.t('per_page', {
              defaultValue: '{{perPage}} pro Seite',
              perPage,
            }), //t('per_page', { perPage }).toString(),
          }),
        )}
        w={130}
        value={perPage.toString()}
        onChange={(v) => setPerPage(parseInt(v ?? '25'))}
        {...perPageSelectInputProps}
      />
    </Group>
  )
  const activePageCount = Math.min(perPage, total - (active - 1) * perPage)
  const paginationToRender = (
    <>
      {pagination}
      <Text
        size={size}
        align="right"
      >
        {isLoading
          ? i18n.t('table_loading_pagination', 'Ergebnisse werden geladen...') // t('table_loading_pagination')
          : i18n.t('pagination_bar_count_text', {
              defaultValue: 'Eintrag {{from}} bis {{to}} von {{total}}',
              from: total === 0 ? 0 : (active - 1) * perPage + 1,
              to: (active - 1) * perPage + activePageCount,
              total,
            })}

        {/* {t('pagination_bar_count_text', {
              from: total === 0 ? 0 : (active - 1) * perPage + 1,
              to: (active - 1) * perPage + activePageCount,
              total,
            })} */}
      </Text>
    </>
  )

  return countTextOrientation === 'group' ? (
    <Group spacing={size}>{paginationToRender}</Group>
  ) : (
    <Stack spacing={size}>{paginationToRender}</Stack>
  )
}

export default PaginationBar
